var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-menu-section"},[_c('span',{staticClass:"header-text menu-link",on:{"click":_vm.openModal}},[_vm._v(_vm._s(_vm._('Вийти')))])])}
var staticRenderFns = []

export { render, staticRenderFns }